<template>
  <div id="vacancysolution" class="vacancysolution" v-loading.body="loading">
    <div style="padding:5px">
      <el-form :model="currentVacancy" ref="vacancy" label-width="220px">
        <el-form-item label="Кандидат">
          <el-row style="height:100%;">
            <el-col :span="6" style="height:100%;">
              <b>{{currentVacancy.fullName}}</b>
            </el-col>
            <el-col :span="18" style="height:100%;">
              <el-button type="primary" @click="downloadApplication" style="width:200px">Скачать заявление</el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="E-mail">
          <el-row style="height:100%;">
            <el-col :span="6" style="height:100%;">
              <b>{{currentVacancy.email}}</b>
            </el-col>
            <el-col :span="18" style="height:100%;">
              <el-button type="primary" @click="openResume" style="width:200px">Просмотреть резюме</el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="Статус заявки">
          <b>{{currentVacancy.statusLabel}}</b>
        </el-form-item>
      </el-form>
    </div>
    <div>Документы</div>
    <el-table
      ref="alreadyUploadedAttachments"
      :data="currentVacancy.attachments"
      style="width: 100%;"
      :height="uploadedAttachmentsTableHeight"
      >
      <el-table-column
        property="label"
        label="Тип"
        class="grid-text-overflow"
        width="210">
        <template slot-scope="scope">
           <el-tooltip class="item" effect="dark" :content="scope.row.label" placement="top">
             <span class="grid-text-overflow">{{ scope.row.label }}</span>
           </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        property="description"
        label="Описание"
        class="grid-text-overflow">
        <template slot-scope="scope">
          <span style="width: 100%; text-align: justify; text-justify: inter-word;  white-space: normal; word-break: normal;">
            {{ scope.row.description }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="Дата загрузки"
        property="uploaded"
        width="150"
        class="grid-text-overflow">
        <template slot-scope="scope">
          <el-icon name="time"></el-icon>
          <el-tooltip class="item" effect="dark" :content="formatDate(scope.row.uploaded)" placement="top">
            <span style="margin-left: 10px" class="grid-text-overflow">{{ formatDate(scope.row.uploaded) }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        label="Операции"
        width="250"
        class="grid-text-overflow">
        <template slot-scope="scope">
          <span v-if="scope.row.isUploaded">
            <el-button
              size="small"
              icon="el-icon-upload2"
              @click="downloadAttachment(scope.$index, scope.row)">Скачать</el-button>
          </span>
        </template>
      </el-table-column>
    </el-table>
    <div style="padding:5px">
      <el-dialog title="Принять решение" :visible.sync="dialogVisible" :close-on-click-modal="false" :show-close="false" :close-on-press-escape="false">
        <el-select v-model="command" placeholder="Выберите вариант решения" style="width:100%;padding-bottom:10px;" @change="changeSolution">
          <el-option
            v-for="item in currentVacancy.decisions"
            :key="item.id"
            :label="item.label"
            :value="item.id">
          </el-option>
        </el-select>
        <span v-if="patternGroupVisible">
          <el-radio-group style="width:100%;padding-bottom:10px;" v-model="selectedPattern" @change="changePattern">
            <span v-for="item in patterns">
               <el-radio :label="item.label" style="padding-right:10px;"></el-radio>
            </span>
          </el-radio-group>
        </span>
        <el-input
          type="textarea"
          :rows="5"
          placeholder="Введите сообщение"
          v-model="message">
        </el-input>
        <el-upload
          drag
          class="upload-demo"
          ref="upload"
          :action="uploadUrl"
          :headers="uploadRequestHeaders"
          :auto-upload="false"
          :fileList = "fileList"
          :before-upload="beforeUpload"
          :on-change="changeFileList"
          :on-success="uploadSuccess"
          :on-error="uploadError"
          :on-remove="removeFile"
          list-type="picture"
          style="width:100%; padding:10px;"
          >
          <i class="el-icon-upload" style="width:100%"></i>
          <div class="el-upload__text"><em>Нажмите на область для выбора файла</em></div>
          <div class="el-upload__tip" slot="tip" style="width:100%; text-align:center;">
            jpg/jpeg/png/pdf файлы размером меньше, чем 5MB
          </div>
        </el-upload>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="acceptAttachment">Принять решение</el-button>
          <el-button @click="cancelAttachment">Отмена</el-button>
        </span>
      </el-dialog>
      <el-row style="height:100%">
        <el-col :span="12" style="height:100%;">
            <el-button type="primary" @click="solution" style="width:98%;" :disabled="!currentVacancy.canMakeDecision">Принять решение</el-button>
        </el-col>
        <el-col :span="12" style="height:100%;">
            <el-button type="danger" @click="cancel" style="width:98%;">Назад</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import config from '../../appsettings.js'
  import layout from '../../api/helpers/layout'
  import grid from '../../api/helpers/grid'
  import extension from '../../api/helpers/file'

  export default {
    name: 'vacancysolution',
    props: ['vacancy', 'candidate'],
    data() {
      return {
        loading: false,
        message: '',
        solutionLabel: '',
        solutionType: null,
        dialogVisible: false,
        fileList: [],
        filesCount: 0,
        uploadUrl: '',
        uploadRequestHeaders: null,
        attachmentToUpload: null,
        command: null,
        patternMessages: [],
        selectedPattern: '',
        currentVacancy: {
          fullName: '',
          email: '',
          messageTemplates: {},
          statusLabel: '',
          canMakeDecision: false,
          decisions: [],
          attachments: []
        },
        uploadedAttachmentsResultsHeight: null,
      }
    },
    computed: {
      disabled() {
        return !(this.vacancy && this.candidate);
      },
      uploadedAttachmentsTableHeight: function() {
        if(!this.uploadedAttachmentsResultsHeight) {
          let height = layout.getParentClientHeight();
          if(height)
            this.uploadedAttachmentsResultsHeight = height - 260;
        }
        return this.uploadedAttachmentsResultsHeight;
      },
      patterns() {
        return this.patternMessages;
      },
      patternGroupVisible() {
        return this.patternMessages && this.patternMessages.length > 1;
      }
    },
    methods: {
      acceptAttachment() {
        if(!this.command) {
          this.$message.error('Пожалуйста, выберите вариант решения');
        } else {
          if(!this.message) {
            this.$message.error('Пожалуйста, введите сообщение');
          } else
            this.uploadDocs();
        }
      },
      cancelAttachment() {
        this.fileList = [];
        this.attachmentToUpload = null;
        this.dialogVisible = false;
      },
      uploadDocs() {
        if(true) {
          this.$gf.getOptions().then(options => {
            this.loading = true;
            options.params = { };
            this.uploadRequestHeaders = options.headers;
            if(this.message) {
              let msg = window.btoa(unescape(encodeURIComponent(this.message)));
              this.uploadRequestHeaders['MessageBody'] = msg;
            }
            let self = this;
            let prefix = config.API_PREFIX;
            this.uploadUrl = `${prefix}vacancy/${this.vacancy}/candidates/${this.candidate}/messagewithfile`;

            let command = this.command;
            self.$http.post(`${prefix}vacancy/${this.vacancy}/candidates/${this.candidate}/decision/${command}`, [], options).then(response => {
              if(this.filesCount > 0) {
                this.$refs.upload.submit();
              } else {
                let msg = { text : this.message };
                self.$http.post(`${prefix}vacancy/${this.vacancy}/candidates/${this.candidate}/message`, msg, options).then(response => {
                  this.docVisible = false;
                  this.loading = false;
                  this.$router.push(config.VACANCY_URL);
                }).catch(data => {
                  this.loading = false;
                  console.log(data);
                  self.$gf.checkError(data)
                });
              }
              this.dialogVisible = false;
            }).catch(data => {
              this.loading = false;
              console.log(data);
              self.$gf.checkError(data)
            });
          }).catch(
            err => {
              this.$gf.catchOptions();
              console.log(err);
            }
          );
        }
      },
      uploadSuccess(response, file, fileList) {
        this.loading = true;
        this.fileList = [];
        this.attachmentToUpload = null;
        this.docVisible = false;
        this.loading = false;
        this.$router.push(config.VACANCY_URL);
      },
      uploadError(err, file, fileList) {
        this.loading = false;
      },
      beforeUpload(file) {
        let ext = extension.getExtension(file.name);
        ext = ext ? ext.toLowerCase() : ext;
        const isImage = ext && (ext === 'jpeg' || ext === 'jpg' || ext === 'png' || ext === 'pdf');
        const isLt5Mb = file.size / 1024 / 1024 <= 5;
        if (!isImage) {
          this.$message.error('Документ должен быть в формате jpg/jpeg/png/pdf');
        }
        if (!isLt5Mb) {
          this.$message.error('Размер документа должен быть меньше 5MB');
        }
        return isImage && isLt5Mb;
      },
      removeFile(file, fileList) {
        this.filesCount = 0;
        if(fileList)
          this.filesCount = fileList.length;
      },
      changeFileList(file, fileList) {
        this.filesCount = 0;
        if(fileList)
          this.filesCount = fileList.length;

        let add = this.beforeUpload(file);
        if(!add) {
          fileList.splice(-1, 1);
        } else {
          if(fileList && fileList.length > 1) {
              this.$message.error('Количество документов не должно превышать 1');
              fileList.splice(-1, 1);
          }
        }
      },
      solution() {
        this.command = null;
        this.message = '';
        this.patternMessages = [];
        this.selectedPattern = '';
        this.dialogVisible = true;
      },
      changeSolution() {
        this.selectedPattern = '';
        this.message = '';
        if(this.currentVacancy && this.command) {
          let decisions = this.currentVacancy.decisions;
          if(decisions) {
            let result = decisions.find( a => { return a.id === this.command; });
            if(result) {
              this.patternMessages = result.messages;
              if(this.patternMessages) {
                if(this.patternMessages.length == 1)
                  this.message = this.patternMessages[0].message;
                else if (this.patternMessages.length > 1) {
                    let result = this.patternMessages.find( a => { return a.isDefault === true; });
                    if(result) {
                      this.selectedPattern = result.label;
                      this.message = result.message;
                    }
                }
              }
            }
          }
        }
      },
      changePattern() {
        if(this.selectedPattern && this.patternMessages) {
          let result = this.patternMessages.find( a => { return a.label === this.selectedPattern; });
          if(result)
            this.message = result.message;
        }
      },
      cancel() {
        this.$router.push(config.VACANCY_URL);
      },
      openResume() {
        this.$router.push(config.RESUME_URL + '/' + this.candidate);
      },
      fetch() {
        this.loading = true;
        let self = this;
        let prefix = config.API_PREFIX;
        this.$gf.getOptions().then(options => {
          options.params = {
          };
          ///VACANCY
          if(this.vacancy && this.candidate) {
              let url = `${prefix}vacancy/${this.vacancy}/candidates/${this.candidate}`;
              self.$http.get(url, options)
                .then(response => {
                  self.currentVacancy = response.data;
                  self.loading = false;
                })
                .catch(data => {
                  self.$gf.checkError(data);
                  self.loading = false;
                });
          }
        }).catch(err => {
          this.$gf.catchOptions();
          this.loading = false;
        });
      },
      downloadAttachment(index, row) {
        let self = this;
        let prefix = config.API_PREFIX;
        this.$gf.getOptions().then(options => {
          options.params = { };
          let url = `candidatesview`;
          self.$http.get(`${prefix}${url}/attachments/${row.uid}`, options)
            .then(response => {
              window.location.href = `${prefix}${url}/attachments/${row.uid}/${response.data}`;
            })
            .catch(data => self.$gf.checkError(data));
          }).catch(err => this.$gf.catchOptions());
      },
      downloadApplication() {
        let self = this;
        let prefix = config.API_PREFIX;
        this.$gf.getOptions().then(options => {
          options.params = { };
          self.$http.get(`${prefix}vacancy/${this.vacancy}/candidates/${this.candidate}/application`, options)
            .then(response => {
              window.location.href = `${prefix}vacancy/${this.vacancy}/candidates/${this.candidate}/application/${response.data}`;
            })
            .catch(data => self.$gf.checkError(data));
          }).catch(err => this.$gf.catchOptions());
      },
      resize() {
        let height = layout.getParentClientHeight();
        if(height) {
          this.uploadedAttachmentsResultsHeight = height - 260;
        } else {
          this.uploadedAttachmentsResultsHeight = null;
        }
      },
      formatDate(d) {
        return grid.formatDate(d);
      }
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.resize);
    },
    created() {
      window.addEventListener('resize', this.resize);
      this.fetch();
    }
  }
</script>

<style scoped>
  .vacancysolution {
    height: calc(100% - 20px);
    border: 1px solid #d1dbe5;
    padding: 10px;
    overflow-y: scroll;
  }
  .el-form-item {
    margin-bottom: 10px !important;
  }
</style>
<style>
  .el-picker-panel {
    min-width: 350px !important;
  }
  .el-upload {
    width: 100% !important;
  }
  .el-upload-dragger {
    width: 100% !important;
    min-width: 360px !important;
  }
  .solution-pattern .el-radio-button__inner {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/personalarea/vacancysolution.vue